import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        obj: {},
        list: [],
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/views/link/ranking/index.js